module.exports = __webpack_public_path__ + "img/rune-haste.495337bd.png";